module.exports = __webpack_public_path__ + "static/media/camera.dfbd3eb3.svg";